import { createAction, createSlice } from '@reduxjs/toolkit';
import { extractSharedActions } from '@sda/utils/store';
import { Reducers } from '@sda/enums/store';
import { createEntityAdapter } from '@client/store/entity.adapter';
import type { Configuration } from '@sda/interfaces/setting/homepage';
import type { FetchDataType } from '@sda/sdk/interfaces';

interface ConsultationEmailPayload {
  readonly name: string;
  readonly email: string;
  readonly location: string;
  readonly website: string;
  readonly comments: string;
  readonly mode: 'artist' | 'host';
}

export const startSendConsultationEmail = createAction<ConsultationEmailPayload>(`${Reducers.HOME}/startSendConsultationEmail`);
export const startUpdateHomepage = createAction<Configuration>(`${Reducers.HOME}/startUpdateHomepage`);
export const startDeepLinkProfile = createAction<string>(`${Reducers.HOME}/startDeepLinkProfile`);
export const startRemovePendingShowReview = createAction(`${Reducers.HOME}/startRemovePendingShowReview`);

export const homeAdapter = createEntityAdapter<Configuration & FetchDataType>();

const homeSlice = createSlice({
  initialState: homeAdapter.getInitialState(),
  name: Reducers.HOME,
  reducers: {
    ...extractSharedActions(homeAdapter),
  },
});

export const {
  upsertOne: upsertHome,
} = homeSlice.actions;

export default homeSlice.reducer;
